import React, { useContext, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Plus } from 'lucide-react';
import ChatbotContext from '../../context/ChatbotContext/ChatbotContext';
import useAuthRoles from '../../hooks/useAuthRoles';
import useChatbotCreation from '../../hooks/useChatbotCreation';
import Button from '../Button/Button';
import DataTableEmptyState from '../DataTable/DataTableEmptyState';
import PageTitleSection from '../PageTitleSection/PageTitleSection';
import CreateEntityModal from '../Navbar/CreateEntityModal/CreateEntityModal';

const ROUTE_TITLES: { prefix: string; title: string }[] = [
  { prefix: '/chats', title: 'Chats' },
  { prefix: '/analytics', title: 'Analytics' },
  { prefix: '/training', title: 'Training' },
  { prefix: '/settings', title: 'Settings' },
  { prefix: '/embed-instructions', title: 'Embedding' }
];

function NoChatbotEmptyState(): React.ReactElement {
  const { selectedOrganisation } = useContext(ChatbotContext);
  const { userIsJapetoAdmin } = useAuthRoles();
  const { createChatbot } = useChatbotCreation();
  const location = useLocation();
  const [showCreateChatbot, setShowCreateChatbot] = useState(false);

  const isAdmin = userIsJapetoAdmin();
  const organisationName = selectedOrganisation?.name || 'This organisation';
  const pageTitle =
    ROUTE_TITLES.find((route) => location.pathname.startsWith(route.prefix))
      ?.title ?? '';

  return (
    <>
      {pageTitle && <PageTitleSection title={pageTitle} />}

      <div className='pt-16'>
        <DataTableEmptyState
          title='No chatbot yet'
          message={
            isAdmin
              ? `${organisationName} doesn’t have a chatbot yet. Create one to get started.`
              : `${organisationName} has no chatbot yet. Please contact your administrator.`
          }
          action={
            isAdmin && selectedOrganisation ? (
              <Button
                onClick={() => setShowCreateChatbot(true)}
                icon={<Plus className='h-4 w-4' />}
              >
                Create chatbot
              </Button>
            ) : undefined
          }
        />
      </div>

      {isAdmin && (
        <CreateEntityModal
          open={showCreateChatbot}
          onClose={() => setShowCreateChatbot(false)}
          title='Create chatbot'
          label='Chatbot name'
          placeholder='Type chatbot name'
          onCreate={createChatbot}
        />
      )}
    </>
  );
}

export default NoChatbotEmptyState;
